import { useState, useEffect } from "react";
import { api, API } from "../App";
import { toast } from "sonner";

export default function AdminBugsPage() {
  const [bugs, setBugs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/bugs").then(r => { setBugs(r.data || []); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(load, []);

  const resolve = async (id) => {
    await api.put(`/bugs/${id}`, { resolved: true });
    toast.success("Bug resolved");
    load();
  };

  const remove = async (id) => {
    await api.delete(`/bugs/${id}`);
    toast.success("Bug deleted");
    load();
  };

  if (loading) return <div className="p-8 text-white">Loading bugs...</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 style={{fontFamily:"var(--font-orb)",fontSize:"20px",color:"var(--t1)",marginBottom:"20px"}}>Bug Reports</h2>
      {bugs.length === 0 && <p className="text-[#666]">No bugs reported yet.</p>}
      {bugs.map(b => (
        <div key={b._id} style={{background:"var(--s2)",border:"1px solid var(--bdr)",borderRadius:"12px",padding:"16px",marginBottom:"12px",opacity:b.resolved?0.5:1}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <h3 style={{fontFamily:"var(--font-orb)",fontSize:"14px",color:b.resolved?"var(--t3)":"var(--t1)",margin:"0 0 4px 0"}}>{b.title} {b.resolved && <span style={{fontSize:"11px",color:"#22c55e"}}>(Resolved)</span>}</h3>
              <p style={{fontSize:"11px",color:"var(--t3)",margin:"0 0 8px 0"}}>By {b.submitted_by_name || b.submitted_by || "Unknown"} &middot; {new Date(b.created_at).toLocaleDateString()}</p>
            </div>
            <div style={{display:"flex",gap:"6px"}}>
              {!b.resolved && <button onClick={()=>resolve(b._id)} style={{fontSize:"11px",padding:"4px 10px",background:"rgba(34,197,94,0.2)",color:"#22c55e",border:"1px solid rgba(34,197,94,0.3)",borderRadius:"6px",cursor:"pointer"}}>Resolve</button>}
              <button onClick={()=>remove(b._id)} style={{fontSize:"11px",padding:"4px 10px",background:"rgba(239,68,68,0.2)",color:"#ef4444",border:"1px solid rgba(239,68,68,0.3)",borderRadius:"6px",cursor:"pointer"}}>Delete</button>
            </div>
          </div>
          {b.description && <p style={{fontSize:"13px",color:"var(--t2)",margin:"0 0 8px 0",whiteSpace:"pre-wrap"}}>{b.description}</p>}
          {b.screenshot_url && <img src={API.replace("/api","") + b.screenshot_url} alt="screenshot" style={{maxWidth:"100%",maxHeight:"300px",borderRadius:"8px",border:"1px solid var(--bdr)"}} onError={(e) => { e.target.style.display = 'none'; }} />}
        </div>
      ))}
    </div>
  );
}
